import Vuex from 'vuex'

export const store = new Vuex.Store({
  /*
  NOTE: As of now, we do not support dynamic + nested modules.
  Ideally if all your modules are dynamic
  then your store is registered initially
  as a completely empty object
  */
})

